const documentaries = [
    {
        alias: "goodpeople",
        navigation: [
            {
                link: "/documentaries/goodpeople",
                title: "Latest",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/1.5475295",
                title: "Full Episodes",
                type: "external",
            },
        ],
    },
    {
        alias: "enslaved",
        navigation: [
            {
                link: "/documentaries/enslaved",
                title: "Latest",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca/enslaved",
                title: "Full Episodes",
                type: "external",
            },
        ],
    },
];

export default documentaries;
